export default __webpack_public_path__ + "static/media/2.6bcede09.png";